import {
  Dialog,
  Box,
  Stack,
  Typography,
  useTheme
} from '@mui/material';

import {
  ModalCommentSection,
  SaveTaskModalDetailSection
} from 'modules/components/layer16';

import React, { ReactNode } from 'react';
import { useParams } from 'react-router-dom';



export type SaveTaskModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
  headerIcon?: ReactNode;
  cancelButton?: {
    text: string;
    handleClick: () => void;
  };
  successButton?: {
    text: string;
    handleClick: () => void;
  };
  title?: string;
  subTitle?: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SaveTaskModalProps) => {
  const params = useParams();
  const theme = useTheme();
  return (
    <Dialog
      open={props.isVisible}
      onClose={() => props.handleClose()}
    >
      <Box
        marginX='-1.25rem'
        paddingX='1.2rem'
        paddingY='.5rem'
        bgcolor={theme.palette.info.main}
      >
        <Typography
          color='white'
          variant='pill'
        >
          Assigned
        </Typography>
      </Box>
      <Stack
        paddingY='1.25rem'
        direction='row'
        height='51.375rem'
        columnGap='1.25rem'
      >
        {/* LEFT FORM DIALOG HEADER NO TEXT */}
        <SaveTaskModalDetailSection.FC
          id={props.id}
          projectId={params.projectId ?? ''}
          handleClose={props.handleClose}
        />


        {/* LEFT FORM DIALOG HEADER NO TEXT */}
        <ModalCommentSection.FC
          taskId={props.id}
        />

      </Stack>

    </Dialog>


  );
};
